var _style, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevenueGrowth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-934 516 50 50",
    style: {
      enableBackground: "new -934 516 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000;}\n\t.st1{fill:#000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-929.6,555.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2S-927.3,555.2-929.6,555.2z    M-929.6,549.7c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2s1.2-0.6,1.2-1.2S-928.9,549.7-929.6,549.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-909,548.3c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2   C-904.8,546.3-906.7,548.3-909,548.3z M-909,542.8c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2s1.2-0.6,1.2-1.2S-908.3,542.8-909,542.8   z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-888.5,535.9c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2S-886.2,535.9-888.5,535.9z    M-888.5,530.4c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2s1.2-0.6,1.2-1.2S-887.9,530.4-888.5,530.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -920.9,
    y: 540.1,
    transform: "matrix(0.2917 0.9565 -0.9565 0.2917 -127.1814 1267.4166)",
    className: "st0",
    width: 3,
    height: 15.4
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -900.2,
    y: 528.3,
    transform: "matrix(0.6016 0.7988 -0.7988 0.6016 71.6716 932.3052)",
    className: "st0",
    width: 3,
    height: 19.4
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-928.1,543.9v-18.3c0-1.4,1.1-2.5,2.5-2.5h15.4v13.8c0.4-0.1,0.8-0.1,1.2-0.1c0.6,0,1.2,0.1,1.8,0.2v-13.9   h14.9c1,0,1.9,0.6,2.3,1.5c0.5-0.1,1-0.2,1.5-0.2c0.5,0,1.1,0.1,1.6,0.2c-0.5-2.6-2.7-4.5-5.4-4.5h-33.3c-3,0-5.5,2.5-5.5,5.5v18.3   c0.5-0.1,1-0.2,1.5-0.2C-929.1,543.7-928.6,543.8-928.1,543.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-888.5,538.9c-0.4,0-0.9,0-1.3-0.1v17.7c0,1.4-1.1,2.5-2.5,2.5h-14.9V551c-0.6,0.1-1.1,0.2-1.8,0.2   c-0.4,0-0.8,0-1.2-0.1v7.8h-15.4c-0.8,0-1.5-0.4-2-1c-0.6,0.2-1.3,0.3-2,0.3c-0.4,0-0.9,0-1.3-0.1c0.7,2.2,2.8,3.8,5.2,3.8h33.3   c3,0,5.5-2.5,5.5-5.5v-17.8C-887.4,538.8-888,538.9-888.5,538.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueGrowth);
export default __webpack_public_path__ + "static/media/revenue-growth.7afa3042d0b5ab4881df2fbc33e6ea53.svg";
export { ForwardRef as ReactComponent };